export default __webpack_public_path__ + "static/2_20-260ba543c55e5bb03dc643fabeb928c7.png";